<template>
  <b-form class="receivement">
    <b-row class="receivement-mobile">
      <labeled-input size="sm" class="col-sm-1-5 mobile-label-input" v-model="receivement.date" type="date" :label="labels ? 'Data' : ''"/>

      <labeled-input size="sm" class="col-sm-2-5  mobile-label-input" :label="labels ? 'Valor' : ''">
        <b-form-select size="sm" slot="prepend" class="prepend-input-group" :value="receivement.currency.id" @input="changeCurrency($event)" :options="currencies" valueField="id" textField="symbol"/>
        <blumar-decimal-input v-model="receivement.value" size="md"/>
      </labeled-input>

      <labeled-input size="sm" class="col-sm-1-1 mobile-label-input" v-model="receivement.exchange" type="exchange" :label="labels ? 'Câmbio' : ''" :disabled="receivement.currency.id === booking.booking.priceCurrency.id"/>

      <labeled-input size="sm" class="col-sm-1-5 mobile-label-input" :label="labels ? 'Valor Final': ''" :value="`${booking.booking.priceCurrency.symbol} ${receivementFinalValue() || ''}`" disabled/>

      <labeled-select size="sm" class="col-sm-1-5 mobile-label-input" :label="labels ? 'Tipo' : ''" v-model="receivement.type" :options="receivementTypes" :show-labels="false" placeholder="" :allow-empty="false"/>

      <div class="receivement-actions col-sm-2">
        <form-button v-if="!noSave && updatableInfoChanged" @click.prevent="saveReceivement" size="sm" />
        <form-button v-if="!noDelete" @click.prevent="deleteReceivement" title="Remover" size="sm" variant="danger" />
        <form-button v-if="!receivement.id" @click.prevent="cancelReceivement" title="Cancelar" size="sm" variant="danger" />
      </div>

    </b-row>
  </b-form>
</template>

<script>
import moment from 'moment';
import ReceivementService from '../../../service/ReceivementService';
import { alerter, formatNumber, getNumber, requestAction } from '../../../utils';

let Currency = {
  REAL: { id: 1, symbol: "R$" },
  DOLAR: { id: 2, symbol: "U$" },
  EURO: { id: 3, symbol: "EUR" },
}

let ReceivementType = {
  CASH: { id: 1, name: "Cash" },
  CARD: { id: 2, name: "Cartão" },
};

let receivement = (r = {}) => ({
  date: r.date || null,
  currency: r.currency || Currency.REAL,
  value: r.value || '0,00',
  type: r.type || ReceivementType.CASH,
  exchange: r.exchange || null,
});

export default {
  props: {
    receivement: { default: receivement },
    booking: {},
    accountability: {},
    labels: {},
    noDelete: {},
    noSave: {},
    useSaveIcon: {},
  },
  data() {
    return {
      service: new ReceivementService(),
      receivementTypes: [
        ReceivementType.CASH,
        ReceivementType.CARD,
      ],
      currencies: [
        Currency.REAL,
        Currency.DOLAR,
        Currency.EURO,
      ],
      updatableInfoChanged: false,

    };
  },
  watch: {
    "receivement.currency"(currency) {
      if (currency.id === this.booking.booking.priceCurrency.id)
        this.receivement.exchange = "1,0000";
    },
    "receivement.type"(newVal, oldVal) {this.updatableInfoChanged = true;},
    "receivement.exchange"(newVal, oldVal) {this.updatableInfoChanged = true;},
    "receivement.value"(newVal, oldVal) {this.updatableInfoChanged = true;},
    "receivement.date"(newVal, oldVal) {this.updatableInfoChanged = true;},
  },
  methods: {
    async saveReceivement() {
      let receivement = {
        ...this.receivement,
        booking: { id: this.booking.id },
        accountability: { id: this.accountability.id },
      };

      if (receivement.currency.id === this.booking.booking.priceCurrency.id)
        receivement.exchange = "1,0000";

      if (!confirm("Deseja realmente salvar o recebimento?")) return;

      if (!moment(receivement.date, 'DD/MM/YYYY').isValid())
        return alerter.warn("Data inválida");
      if (!receivement.value)
        return alerter.warn("Preencha o campo valor");
      if (!receivement.exchange)
        return alerter.warn("Preencha o campo câmbio");

      let success = "Recebimento salvo com sucesso";
      let failure = "Falha ao salvar recebimento";
      receivement = await requestAction(success, failure, () => this.service.save(receivement));
      this.$emit('update:receivement', receivement);
      this.$nextTick(() => {
        setTimeout(() => {this.updatableInfoChanged = false;}, 0);
      })
    },
    receivementFinalValue() {
      let exchange = getNumber(this.receivement.exchange);
      let value = getNumber(this.receivement.value);

      if (typeof exchange !== 'number') return formatNumber(value, 2);

      let bookingCurrency = this.booking.booking.priceCurrency || Currency.REAL;

      let convert = () => {
        if (!bookingCurrency || this.receivement.currency.id < bookingCurrency.id)
          return value / exchange;
        else if (this.receivement.currency.id > bookingCurrency.id)
          return value * exchange;
        else
          return value;
      }

      return formatNumber(convert(), 2) || '';
    },
    changeCurrency(id) {
      this.receivement.currency = this.currencies.find(c => c.id === id);
    },
    async deleteReceivement() {
      if (confirm("Deseja realmente remover esse recebimento?")) {
        let success = "Recebimento removido com sucesso";
        let failure = "Falha ao remover recebimento";
        await requestAction(success, failure, () => this.service.delete(this.receivement.id));
        this.$emit("removed", this.receivement.id);
      }
    },
    cancelReceivement() {
      this.$emit('remove:receivement', receivement);
    },
  },
}
</script>

<style scoped>
.prepend-input-group {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 1;
}

.receivement-save-button {
  margin-left: auto;
  margin-right: 16px;
}

.col-sm-1-5 {
  flex: 0 0 12.99999%;
  max-width: 12.99999%;
}

.col-sm-2-5 {
  flex: 0 0 17.55555%;
  max-width: 17.55555%;
}

.delete-button {
  margin-left: 5px;
  margin-top: 10px;
  cursor: pointer;
}

.pointer {
  cursor: pointer;
}

.receivement-mobile{
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 0% 2%;
}

.receivement-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 8%;
  margin-bottom: 1%;
}


@media screen and (max-width: 750px){
  .receivement-mobile{
    display: flex;
    flex-direction: column;
  }
  .receivement-actions {
    margin-top: 2%;
    width: 100%;
    margin-left: 5%;
  }
  .mobile-label-input {
    max-width: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/os/accountability/Receivement.vue